import React, {Component} from 'react';
import {injectIntl} from 'react-intl';

import messages from './messages';
import {PasswordCheck, CheckWrapper, StyledIcon, PasswrodChecklistWrapper} from './styles';

class PasswordChecklist extends Component {
  render() {
    const {
      password,
      isInputFocused,
      intl: {formatMessage}
    } = this.props;

    if (!password) {
      return null;
    }

    const hasMinCharacters = password.length >= 8;
    const hasLowercaseChar = /[a-z]/.test(password);
    const hasUppercaseChar = /[A-Z]/.test(password);
    const containsNumber = /\d/.test(password);
    const containsNonAlphaChar = /[^a-zA-Z0-9\s:]/.test(password);
    const allChecksPassed =
      hasMinCharacters && hasLowercaseChar && hasUppercaseChar && containsNumber && containsNonAlphaChar;

    if (allChecksPassed && !isInputFocused) {
      return null;
    }

    return (
      <PasswrodChecklistWrapper>
        <CheckWrapper>
          <PasswordCheck checked={hasMinCharacters} data-testid={`min-chars-${hasMinCharacters}`}>
            <StyledIcon name={hasMinCharacters ? 'checkmark' : 'close'} />
          </PasswordCheck>
          <div>{formatMessage(messages.minCharactersPassword, {value: 8})}</div>
        </CheckWrapper>
        <CheckWrapper>
          <PasswordCheck checked={hasLowercaseChar} data-testid={`lowercase-char-${hasLowercaseChar}`}>
            <StyledIcon name={hasLowercaseChar ? 'checkmark' : 'close'} />
          </PasswordCheck>
          <div>{formatMessage(messages.lowercaseLettersPassword, {value: 1})}</div>
        </CheckWrapper>
        <CheckWrapper>
          <PasswordCheck checked={hasUppercaseChar} data-testid={`uppercase-char-${hasUppercaseChar}`}>
            <StyledIcon name={hasUppercaseChar ? 'checkmark' : 'close'} />
          </PasswordCheck>
          <div>{formatMessage(messages.uppercaseLettersPassword, {value: 1})}</div>
        </CheckWrapper>
        <CheckWrapper>
          <PasswordCheck checked={containsNumber} data-testid={`number-char-${containsNumber}`}>
            <StyledIcon name={containsNumber ? 'checkmark' : 'close'} />
          </PasswordCheck>
          <div>{formatMessage(messages.nummbersInPassword, {value: 1})}</div>
        </CheckWrapper>
        <CheckWrapper>
          <PasswordCheck checked={containsNonAlphaChar} data-testid={`nonalpha-char-${containsNonAlphaChar}`}>
            <StyledIcon name={containsNonAlphaChar ? 'checkmark' : 'close'} />
          </PasswordCheck>
          <div>{formatMessage(messages.nonAlphaInPassword, {value: 1})}</div>
        </CheckWrapper>
      </PasswrodChecklistWrapper>
    );
  }
}

export default injectIntl(PasswordChecklist);
